<template>
  <main class="school-university">
    <su-form-modal
      v-if="modal"
      :modal-type="modalType"
      :modal-comment="modalComment"
      @close="closeModal"
    />

    <su-zero @openModal="openModal" />

    <main-certificate />

    <su-skills @openModal="openModal" />

    <su-tests />

    <su-career-guidance />

    <su-team />

    <su-platform />

    <school-tariffs />

    <su-reviews />

    <su-form />

    <olga-block />

    <su-faq />
  </main>
</template>

<script>
import HeadMixin from '@/mixins/HeadMixin';

import SuZero from '../../components/v2/school-university/SuZero.vue';
import SuSkills from '../../components/v2/school-university/skills/SuSkills.vue';
import SuTests from '../../components/v2/school-university/SuTests.vue';
import SuCareerGuidance from '../../components/v2/school-university/SuCareerGuidance.vue';
import SuTeam from '../../components/v2/school-university/SuTeam.vue';
import SuFaq from '../../components/v2/school-university/SuFaq.vue';
import SuForm from '../../components/v2/school-university/SuForm.vue';
import SuPlatform from '../../components/v2/school-university/SuPlatform.vue';
import SuReviews from '../../components/v2/school-university/SuReviews.vue';
import SuFormModal from '../../components/v2/school-university/SuFormModal.vue';
import MainCertificate from '../../components/v2/main/MainCertificate.vue';
import OlgaBlock from '../../components/v2/common/OlgaBlock.vue';
import SchoolTariffs from '../../components/v2/school-new/SchoolTariffs.vue';

export default {
  name: 'SchoolUniversity',
  components: {
    SchoolTariffs,
    OlgaBlock,
    SuFormModal,
    SuReviews,
    SuPlatform,
    SuForm,
    SuFaq,
    SuTeam,
    SuCareerGuidance,
    SuTests,
    SuSkills,
    SuZero,
    MainCertificate,
  },
  mixins: [HeadMixin],
  layout: 'DefaultLayoutV2',

  data: () => ({
    modal: false,
    modalType: null,
    modalComment: null,

    // для head
    title: 'Школьный Университет Синергия — профильная домашняя школа для 5–11 классов',
    // eslint-disable-next-line max-len,vue/max-len
    description: 'Домашняя школа «Синергия» это: вебинары и мини-группы, программа ФГОС, аттестат гос. образца и обучение востребованным навыкам и профессиям будущего',
    image: '/v2/school-university/share-image.jpg',
  }),

  methods: {
    openModal(modalType, modalComment = null) {
      this.modalType = modalType;
      this.modalComment = modalComment;
      this.modal = true;
    },
    closeModal() {
      this.modal = false;
      this.modalType = null;
      this.modalComment = null;
    },
  },
};
</script>

<style scoped lang="scss">

.school-university {
  margin-inline: auto;
  padding-inline: var(--padInline);
  background-color: #ECEDF0;

  display: flex;
  flex-direction: column;
  gap: 8rem;

  ::v-deep(*) {
    font-family: "Onest", sans-serif;
  }

  ::v-deep(.su-header) {
    position: fixed;
    z-index: 5;
    top: 0;
    left: 0;

    padding-inline: var(--padInline);
  }

  ::v-deep(.su-zero) {
    padding-top: 7rem;

    @include media-down($size-tablet) {
      padding-top: 6.4rem;
    }
  }

  ::v-deep(.su-footer) {
    @include media-down($size-mobile) {
      margin-top: -4rem;
    }
  }

  ::v-deep(.su-title) {
    position: relative;

    p {
      position: absolute;
      left: 0;
      top: 1.25rem;

      font-weight: 500;
      font-size: 1.625rem;
      line-height: 120%;
      color: #A7ABAC;

      @include media-down($size-tablet) {
        font-size: 1.8rem;
      }

      @include media-down($size-mobile) {
        position: relative;
        top: 0;
        margin-bottom: -0.2rem;
      }

      & + h2 {
        text-indent: calc(var(--scale) * 465);

        @include media-down($size-tablet) {
          text-indent: calc(var(--scale) * 186);
        }

        @include media-down($size-mobile) {
          text-indent: 0;
        }
      }
    }

    h2 {
      font-weight: 500;
      font-size: 5.375rem;
      line-height: 110%;
      letter-spacing: -0.04em;
      color: #02120F;

      @include media-down($size-tablet) {
        font-size: 4rem;
      }

      span {
        color: #FF5319;
      }
    }
  }

  ::v-deep(.video-modal) {
    z-index: 11;

    &:before {
      background-color: rgba( #02120F, 0.3);
      backdrop-filter: blur(5px);
    }

    .video-modal__inner {
      position: static;
      border-radius: calc(var(--scale) * 40);
      box-shadow: none;
      line-height: 0;
    }

    .video-modal__close {
      display: grid;
      place-content: center;
      right: calc(var(--scale) * 40);
      top: calc(var(--scale) * 30);
      width: calc(var(--scale) * 33);
      height: calc(var(--scale) * 33);
      background-color: #ECEDF0;
      border-radius: 50%;

      img {
        background-color: transparent;
        border: none;
        box-shadow: none;
        width: calc(var(--scale) * 16);
        height: calc(var(--scale) * 16);
        transform: none;
      }
    }
  }
}

</style>

<style lang="scss">

:root {
  --scale: calc(100vw / 1920);
  --padInline: calc(var(--scale) * 40);
}

@media only screen and (max-width: 1200px) {
  :root {
    --scale: calc(100vw / 768);
    --padInline: calc(var(--scale) * 16);
  }
}

@media only screen and (max-width: 767px) {
  :root {
    --scale: calc(100vw / 390);
    --padInline: calc(var(--scale) * 12);
  }
}

html {
  font-size: calc(var(--scale) * 16);
}

html,
body {
  scrollbar-gutter: stable;
}

@media only screen and (max-width: 1200px) {
  html {
    font-size: calc(var(--scale) * 10);
  }
}

</style>
